import { WirCreateTabs } from 'pages/WellGuardian/WIR/wir.constants';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  updateOriginalSelectedWIR,
  updateSelectedWIR,
  updateWIRCreateSelectedTab,
  updateWIRList,
} from '../../../../redux/WellGuardian';
import { useCountryState } from '../../../../redux/WellGuardian/selectors';
import wellGuardianApiClient from 'services/networking/wellGuardianApiClient';

export const useFetchWgWIRList = () => {
  const [wirListLoading, setWirListLoading] = useState<boolean>(false);
  const countrySelect = useCountryState();

  const dispatch = useDispatch();

  const fetchWIRsList = useCallback(async () => {
    if (!countrySelect) return;

    dispatch(updateSelectedWIR(null));
    dispatch(updateOriginalSelectedWIR(null));
    dispatch(updateWIRCreateSelectedTab(WirCreateTabs.ACTIVITY_LABEL));
    setWirListLoading(true);

    try {
      const wirResponse = await wellGuardianApiClient.getAllWir(countrySelect);
      const sortedResponse = wirResponse.sort((a, b) =>
        (b.wirNumber?.split('WIR')[1] ?? '').localeCompare(a.wirNumber?.split('WIR')[1] ?? ''),
      );
      dispatch(updateWIRList(sortedResponse));
    } catch {
      dispatch(updateWIRList([]));
    } finally {
      setWirListLoading(false);
    }
  }, [dispatch, countrySelect]);

  return {
    wirListLoading,
    fetchWIRsList,
  };
};
